import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=d9f673ac&lang=scss&scoped=true"
import "./App.vue?vue&type=style&index=1&id=d9f673ac&lang=scss"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d9f673ac"]])

export default __exports__